import React, { createContext } from "react";
import { useSocketLegacy } from "../hooks/useSocketLegacy";
import { useSocket } from "../hooks/useSocket";

export const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
    const { socket: socketLegacy }  = useSocketLegacy(process.env.REACT_APP_SKYCOMMS_SOCKET);
    const { socket: socketGateway, online: gatewayOnline } = useSocket(process.env.REACT_APP_SKYCOMMS_GATEWAY_SOCKET);

    return (
        <SocketContext.Provider value={{ socket: socketLegacy, socketGateway, gatewayOnline }}>
            {children}
        </SocketContext.Provider>
    );
};
